import React from 'react';

function Loading() {

return (
<div className="load-container">
<div className="load-5">
  {/* <p>Loading 5</p> */}
  <div className="ring-2">
    <div className="ball-holder">
      <div className="ball"></div>
    </div>
  </div>
</div>
</div>
    );
}

export default Loading;